import EventEmitter from 'events';
import store from 'store/dist/store.modern';

const eventEmitter = new EventEmitter();

export function get(key) {
  let value;
  try {
    value = store.get(key);
  } catch (_) {
    // pass
  }
  return value;
}

export function storageEmitter() {
  return eventEmitter;
}

export function set(key, value) {
  try {
    store.set(key, value);
    eventEmitter.emit('change');
  } catch (_) {
    // pass
  }
}

export function remove(key) {
  try {
    store.remove(key);
    eventEmitter.emit('change');
  } catch (_) {
    // pass
  }
}
